import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import loaderAnimation from "assets/animations/loader-document.json";
import { useReducedMotion } from "hooks/useReducedMotion";
import { LottieAnimation } from "./LottieAnimation";

export function FullLoader() {
	const reduced = useReducedMotion();

	if (reduced) {
		return (
			<Spin
				style={spinStyle}
				indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />}
			/>
		);
	}

	return (
		<div style={spinStyle}>
			<div style={contentStyle}>
				<LottieAnimation
					animationData={loaderAnimation}
					loop
					autoplay
					style={lottieStyle}
				/>
				<span style={labelStyle}>Loading...</span>
			</div>
		</div>
	);
}

const spinStyle: React.CSSProperties = {
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	height: "100%",
};

const contentStyle: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	gap: 12,
};

const lottieStyle: React.CSSProperties = {
	width: 120,
	height: 120,
};

const labelStyle: React.CSSProperties = {
	fontSize: 13,
	color: "var(--color-text-secondary)",
	fontWeight: 500,
	letterSpacing: "0.02em",
};
